import { IonButton, IonButtons } from '@ionic/react';
import { Trans, t } from '@lingui/macro';
import { useAtom } from 'jotai/index';
import React, { useCallback, useEffect } from 'react';

import Page from '../components/page/Page';
import { resetAllAtom, resetInterventionAtom } from '../store/Atoms';
import { useCustomRouter } from '../utils/hooks/useCustomRouter';
import { JobType } from './Jobs';

type LoadableContentProps = {
    onJobTypeHandler: () => void;
    jobType: JobType;
    children: React.ReactNode;
};

const JobsPage: React.FunctionComponent<LoadableContentProps> = ({
    onJobTypeHandler,
    jobType,
    children,
}) => {
    const router = useCustomRouter();
    const [, resetAll] = useAtom(resetAllAtom);
    const [, resetJobsList] = useAtom(resetInterventionAtom);

    const handleLogout = useCallback(() => {
        router.push('/login', 'back', 'pop');
        // Ionic will make a transition to the login page so we need to wait for it
        // to finish before resetting the atoms
        setTimeout(() => {
            resetAll();
        }, 1000);
    }, [resetAll, router]);

    useEffect(() => {
        (window as any).resetJobsList = resetJobsList;
    }, [resetJobsList]);

    const onJobButtonHandler = () => {
        onJobTypeHandler && onJobTypeHandler();
    };

    return (
        <Page
            title={
                jobType === JobType.PAST
                    ? t`Done Interventions`
                    : t`Interventions`
            }
            ionButtons={
                <>
                    <IonButtons slot="start">
                        <IonButton onClick={onJobButtonHandler}>
                            {jobType === JobType.PAST ? (
                                <Trans>To do</Trans>
                            ) : (
                                <Trans>Completed</Trans>
                            )}
                        </IonButton>
                    </IonButtons>
                    <IonButtons slot="end">
                        <IonButton onClick={handleLogout}>
                            <Trans>Logout</Trans>
                        </IonButton>
                    </IonButtons>
                </>
            }
        >
            {children}
        </Page>
    );
};

export default JobsPage;
